import { useParams } from 'react-router';

import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { EpsiOrderDetail } from '../../epsi/orders/EpsiOrderDetail';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejEpsiOrderDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { apps, vydej } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej && vydej?.modules?.epsi ? (
        <AppWrapper appType={APP_TYPE.VYDEJ} menu={<VydejMenu />}>
          <EpsiOrderDetail orderId={id!} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejEpsiOrderDetailPage;
